export const openWindow = (src: string) => {
    window.open(src);
};